module.exports = __webpack_public_path__ + "files/7b91c0d5ee769b4276d7d4ec39911f74.png";